import { render, staticRenderFns } from "./WorkIconColorSelection.vue?vue&type=template&id=3ebe7060"
import script from "./WorkIconColorSelection.vue?vue&type=script&lang=js"
export * from "./WorkIconColorSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports